var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4546 12.68L28.0373 9.13925C27.766 8.85813 27.4174 8.72173 27.024 8.72173C26.6307 8.72173 26.282 8.85813 26.0107 9.13925C25.7413 9.41838 25.6117 9.77364 25.6007 10.1711C25.5896 10.5747 25.7092 10.9394 25.9848 11.225L30.4413 15.8425C30.5801 15.9863 30.7417 16.0994 30.9272 16.168C31.0956 16.2303 31.2725 16.26 31.4546 16.26C31.6368 16.26 31.8136 16.2303 31.9821 16.168C32.1676 16.0994 32.3291 15.9863 32.4679 15.8425L42.0028 5.96327C42.2753 5.68094 42.4 5.32102 42.4 4.92039C42.4 4.51976 42.2753 4.15983 42.0028 3.8775C41.7291 3.59394 41.3748 3.45999 40.9766 3.45999C40.5783 3.45999 40.224 3.59394 39.9503 3.8775L31.4546 12.68Z",
    fill: "#1256E9",
    stroke: "#1256E9",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6485 22.3852C31.7003 22.3852 30.4443 22.3642 28.8807 22.3642C25.0673 22.3642 21.9316 19.2079 21.9316 15.3586V8.60501C21.9316 8.07371 21.5076 7.64111 20.9813 7.64111H9.87362C4.68986 7.64111 0.5 11.8957 0.5 17.11V39.7375C0.5 45.208 4.88946 49.6411 10.3061 49.6411H26.8472C32.0122 49.6411 36.2 45.4138 36.2 40.1953V23.3302C36.2 22.7968 35.7779 22.3663 35.2498 22.3684C34.3619 22.3747 33.2972 22.3852 32.6485 22.3852Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9956 28.4283H23.4281C24.2912 28.4283 24.9926 29.1276 24.9926 29.9907C24.9926 30.8538 24.2912 31.5552 23.4281 31.5552H11.9956C11.1325 31.5552 10.4332 30.8538 10.4332 29.9907C10.4332 29.1276 11.1325 28.4283 11.9956 28.4283Z",
    fill: "#96B1EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3039 36.8161H11.9953C11.1322 36.8161 10.4329 37.5154 10.4329 38.3785C10.4329 39.2416 11.1322 39.9431 11.9953 39.9431H23.3039C24.167 39.9431 24.8684 39.2416 24.8684 38.3785C24.8684 37.5154 24.167 36.8161 23.3039 36.8161Z",
    fill: "#96B1EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/Registered.7cc3e0c011cc2b4d12be48449a4990ad.svg";
export { ForwardRef as ReactComponent };